var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledStar = function SvgFilledStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB50",
    stroke: "#FFCB50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3.329,
    strokeWidth: 3.333,
    d: "M18.847 4.43c.428-1.025 1.88-1.025 2.307 0l3.67 8.79c.17.41.545.697.985.757l9.67 1.309c1.084.146 1.47 1.515.624 2.207l-7.468 6.093a1.25 1.25 0 0 0-.427 1.25l2.387 10.317c.259 1.117-.997 1.964-1.936 1.305l-7.94-5.573a1.25 1.25 0 0 0-1.437 0l-7.94 5.573c-.939.659-2.195-.188-1.936-1.305l2.387-10.317a1.25 1.25 0 0 0-.428-1.25L3.9 17.493c-.848-.692-.461-2.06.622-2.207l9.67-1.31c.44-.059.816-.347.987-.756z"
  })));
};
export default SvgFilledStar;